shadow$provide[439] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 scaleAxis;
uniform vec4 scaleOffset;

vec4 sampleData(float x);

vec4 getScalePosition(vec4 xyzw) {
  return scaleAxis * sampleData(xyzw.x).x + scaleOffset;
}
`;

};